/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiCampaignFromJSON, ApiCampaignToJSON, } from './ApiCampaign';
import { ApiComponentFromJSON, ApiComponentToJSON, } from './ApiComponent';
import { ApiExternalDomainFromJSON, ApiExternalDomainToJSON, } from './ApiExternalDomain';
import { ApiMediaFromJSON, ApiMediaToJSON, } from './ApiMedia';
import { ApiPathStatusFromJSON, ApiPathStatusToJSON, } from './ApiPathStatus';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
export function ApiLandingPathFromJSON(json) {
    return ApiLandingPathFromJSONTyped(json, false);
}
export function ApiLandingPathFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'campaign': !exists(json, 'campaign') ? undefined : ApiCampaignFromJSON(json['campaign']),
        'campaignId': !exists(json, 'campaignId') ? undefined : json['campaignId'],
        'canonical': !exists(json, 'canonical') ? undefined : json['canonical'],
        'component': !exists(json, 'component') ? undefined : ApiComponentFromJSON(json['component']),
        'componentId': !exists(json, 'componentId') ? undefined : json['componentId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'deferIncendiumjs': !exists(json, 'deferIncendiumjs') ? undefined : json['deferIncendiumjs'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'invalidationRequestId': !exists(json, 'invalidationRequestId') ? undefined : json['invalidationRequestId'],
        'landingDomainId': !exists(json, 'landingDomainId') ? undefined : json['landingDomainId'],
        'noIndex': !exists(json, 'noIndex') ? undefined : json['noIndex'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'pending': !exists(json, 'pending') ? undefined : (new Date(json['pending'])),
        'pendingComponent': !exists(json, 'pendingComponent') ? undefined : ApiComponentFromJSON(json['pendingComponent']),
        'pendingComponentId': !exists(json, 'pendingComponentId') ? undefined : json['pendingComponentId'],
        'pendingPath': !exists(json, 'pendingPath') ? undefined : json['pendingPath'],
        'pendingStatus': !exists(json, 'pendingStatus') ? undefined : ApiPathStatusFromJSON(json['pendingStatus']),
        'pendingSubdomain': !exists(json, 'pendingSubdomain') ? undefined : ApiExternalDomainFromJSON(json['pendingSubdomain']),
        'pendingSubdomainId': !exists(json, 'pendingSubdomainId') ? undefined : json['pendingSubdomainId'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'screenshot': !exists(json, 'screenshot') ? undefined : ApiMediaFromJSON(json['screenshot']),
        'screenshotId': !exists(json, 'screenshotId') ? undefined : json['screenshotId'],
        'status': !exists(json, 'status') ? undefined : ApiPathStatusFromJSON(json['status']),
        'subdomain': !exists(json, 'subdomain') ? undefined : ApiExternalDomainFromJSON(json['subdomain']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiLandingPathToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'campaign': ApiCampaignToJSON(value.campaign),
        'campaignId': value.campaignId,
        'canonical': value.canonical,
        'component': ApiComponentToJSON(value.component),
        'componentId': value.componentId,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'deferIncendiumjs': value.deferIncendiumjs,
        'description': value.description,
        'id': value.id,
        'invalidationRequestId': value.invalidationRequestId,
        'landingDomainId': value.landingDomainId,
        'noIndex': value.noIndex,
        'path': value.path,
        'pending': value.pending === undefined ? undefined : (value.pending.toISOString()),
        'pendingComponent': ApiComponentToJSON(value.pendingComponent),
        'pendingComponentId': value.pendingComponentId,
        'pendingPath': value.pendingPath,
        'pendingStatus': ApiPathStatusToJSON(value.pendingStatus),
        'pendingSubdomain': ApiExternalDomainToJSON(value.pendingSubdomain),
        'pendingSubdomainId': value.pendingSubdomainId,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'screenshot': ApiMediaToJSON(value.screenshot),
        'screenshotId': value.screenshotId,
        'status': ApiPathStatusToJSON(value.status),
        'subdomain': ApiExternalDomainToJSON(value.subdomain),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
